import { db, auth, COLLECTIONS, SUBCOLLECTIONS } from "../../firebase/firebase";
import {
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  collection,
  getDocs,
  QueryDocumentSnapshot,
  query,
  where,
  limit,
  startAfter,
  QueryConstraint,
  and,
  QueryCompositeFilterConstraint,
  QueryNonFilterConstraint,
  QueryFieldFilterConstraint,
  Timestamp,
  collectionGroup,
  orderBy,
  getCountFromServer,
  setDoc,
  endBefore,
  limitToLast
} from "firebase/firestore";


import { CustomError } from "../../utils/customeError";
import { ChannelActionType, ChannelState, ChannelSubstate, getChannelHistoryStatusString, getChannelStatusString, SKChannel,SKChannelReport,SKChannelStatusHistory } from "../../models/SKChannel";
import { Pagination } from "../enums";



const createChannel = async (data:any) : Promise<string> => {
  if(auth.currentUser?.uid){
    try {
      let channelData = {...data, createdDate: Timestamp.now(), updatedDate: Timestamp.now(), userId: auth.currentUser.uid, members:[auth.currentUser.uid], status:ChannelState.DRAFT,subStatus:ChannelSubstate.NONE, channelMembers:{[auth.currentUser.uid]:'admin'}}
      const docRef = await addDoc(collection(db, COLLECTIONS.CHANNELS), channelData);
      await updateChannelHistory(docRef.id, "created")
      return docRef.id;
    } catch (error) {
      throw new CustomError('An error occurred while creating Channel');
    }
  }else{
    throw new CustomError('User not signed in');
  }
};

const createChannelEdits = async (channelId:string, data:any) : Promise<SKChannel> => {
  if(auth.currentUser?.uid){
    try {
      let channelData = {...data, createdDate: Timestamp.now(), updatedDate: Timestamp.now(), userId: auth.currentUser.uid, members:[auth.currentUser.uid], subStatus:ChannelSubstate.EDIT_IN_DRAFT, channelMembers:{[auth.currentUser.uid]:'admin'}}

      const docRef = doc(db, COLLECTIONS.CHANNEL_CHANGE_REQUESTS, channelId);
      //const docRef = await addDoc(collection(db, COLLECTIONS.CHANNEL_CHANGE_REQUESTS), channelData);
      await setDoc(docRef, channelData);
      await updateChannelEditStatus(docRef.id, ChannelState.ACTIVE, ChannelSubstate.EDIT_IN_DRAFT)
      return {...channelData, id:channelId, status:ChannelState.ACTIVE, subStatus:ChannelSubstate.EDIT_IN_DRAFT};
    } catch (error) {
      throw new CustomError('An error occurred while creating Channel');
    }
  }else{
    throw new CustomError('User not signed in');
  }
};

const getChannel = async (channelId: string) : Promise<SKChannel> => {
  const docSnap = await getDoc(doc(db, COLLECTIONS.CHANNELS, channelId));
  if (docSnap.exists()) {
    return docSnap.data() as SKChannel;
  } else {
    throw new Error("Channel does not exist!");
  }
};


const getChannlesByIds = async (ids: string[]) : Promise<SKChannel[]> => {
   
  const colRef = collection(db, COLLECTIONS.CHANNELS);

  // Use "where" clause with "__name__" for document IDs
  const q = query(colRef, where("__name__", "in", ids));
  const querySnapshot = await getDocs(q);

  const documents = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  } as SKChannel)) ;

  return documents;
};

/* const getChannelByStatus = async (status: string) : Promise<SKChannel> => {
  const querys = query(collection(db, COLLECTIONS.CHANNELS), where('status', '==', 'draft'), where('userId', '==', auth.currentUser?.uid));
  try
  {
    const docSnap = await getDocs(querys);
    const channelsData = docSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data() as SKChannel
    }));
    return channelsData;
  }
  catch (error) {
    throw new Error("Channel does not exist!");
  }

}; */



// querySnapshot.forEach((doc) => {
//   console.log(doc.id, ' => ', doc.data());
// });

const getMyChannel = async (): Promise<SKChannel> => {

  // if (!auth.currentUser?.uid) {
  //   throw new CustomError('User not signed in');
  // }
  let qry = query(collectionGroup(db,COLLECTIONS.CHANNELS), where("members", "array-contains", auth.currentUser?.uid))
  
  try {
    const querySnapshot = await getDocs(qry);
    const channelsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as SKChannel[];
    return channelsData[0];
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const getChannelEdits = async (channelId:string): Promise<SKChannel> => {
    const channelEditRef = doc(db, COLLECTIONS.CHANNEL_CHANGE_REQUESTS, channelId)
    const docSnap = await getDoc(channelEditRef);
  
    if (docSnap.exists()) {
        return {...docSnap.data() ,id: docSnap.id,} as SKChannel;
      
    } else {
      throw new Error("Artifact does not exist!");
    }
};


const getUserCreatedChannel = async (): Promise<SKChannel> => {
  let ref = collection(db, COLLECTIONS.CHANNELS)
  let constraint: QueryConstraint =   where("userId", "==", auth.currentUser?.uid)
  const q  = query(ref, constraint);
  try {
    const querySnapshot = await getDocs(q);
    const channelsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as SKChannel[];
    return channelsData[0];
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const applyPaginationQuery = (pageSize: number, moveTo?:Pagination, currentDoc?:QueryDocumentSnapshot): QueryNonFilterConstraint[] =>{

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  switch (moveTo) {
    case Pagination.Next:
      if (currentDoc) {
        myNonFilterQuery.push(startAfter(currentDoc))
        myNonFilterQuery.push(limit(pageSize));
      }
      break;

    case Pagination.Previous:
      if (currentDoc) {
        myNonFilterQuery.push(endBefore(currentDoc))
        myNonFilterQuery.push(limitToLast(pageSize));
      }
      break;

    case Pagination.First:
      myNonFilterQuery.push(limit(pageSize));
      break;

    case Pagination.Last:
      myNonFilterQuery.push(limitToLast(pageSize));
      break;

    // default:
    //   myNonFilterQuery.push(limit(pageSize));
      
  }

  return myNonFilterQuery;

}

 const fetchChannel = async (filterFields: string[], operator:string, filterValues: unknown[], pageSize: number, lastDocument?:QueryDocumentSnapshot, isFlagged?:boolean, moveTo?:Pagination, sortConfig?:{key:string; direction: "asc" | "desc"} ): Promise<{docs:SKChannel[]; firstDoc: QueryDocumentSnapshot | undefined; lastDoc: QueryDocumentSnapshot | undefined, hasNext:boolean, hasPrev:boolean }> => {
  let ref = collection(db, COLLECTIONS.CHANNELS)
  // let myNonFilterQuery: QueryNonFilterConstraint[] = []
  // myNonFilterQuery.push(limit(pageSize ? pageSize + 1 :  10))

  let myNonFilterQuery = applyPaginationQuery(moveTo === Pagination.Last ? pageSize: pageSize + 1 ,moveTo, lastDocument);

  let constratints:QueryFieldFilterConstraint[]  = []
  
  if (filterFields.length > 0 && filterValues.length > 0) {
    for (let i = 0; i < filterFields.length; i++) {
      const fieldPath = filterFields[i] as string;
      const fieldValue = filterValues[i] as string;
      if(fieldPath && fieldValue) constratints.push(where(fieldPath, '==', fieldValue));
    }
  }


  // if (lastDocument) {
  //   myNonFilterQuery.push(startAfter(lastDocument))
  // }
  if(isFlagged){
    constratints.push(where("flagged", "==", true))
  }
  let compositeQuery: QueryCompositeFilterConstraint =  and(...constratints)

  let sortArray = [orderBy("createdDate", "desc")]

  if(sortConfig){
    sortArray= [orderBy(sortConfig.key, sortConfig.direction)]
  }

  const q  = query(ref, compositeQuery , ...sortArray, ...myNonFilterQuery);
  try {
    const querySnapshot = await getDocs(q);
    // const channelsData = querySnapshot.docs.map(doc => ({
    //   id: doc.id,
    //   ...doc.data()
    // })) as SKChannel[];

        const docs = querySnapshot.docs.slice(0, pageSize).map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as SKChannel[];
    
        // const firstDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[0] : undefined;
        // const lastDoc = querySnapshot.docs.length > 0 ? querySnapshot.docs[querySnapshot.docs.length - 1] : undefined;
        // const hasNext = querySnapshot.size === pageSize;
    
        let firstDoc = querySnapshot.size > 0 ? querySnapshot.docs[0] : undefined;
        // setLastVisible(docs.length > pageSize ? docs[pageSize - 1] : null);
        let lastDoc = querySnapshot.size > pageSize ? querySnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? querySnapshot.docs[pageSize - 1]: undefined);
        let hasNext = moveTo === Pagination.Next ? querySnapshot.size > pageSize :  moveTo === Pagination.First && querySnapshot.size <= pageSize ? false : true;
        
    
        let hasPrev = !!lastDocument;
        switch (moveTo) {
          case Pagination.First:
            hasPrev = false
            break;
          case Pagination.Last:
            hasNext = false
            break;
          default:
            break;
        }
        return {docs,firstDoc,lastDoc,hasNext, hasPrev };

    // return channelsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

 const updateChannel = async (channelId: string, data: any) => {
  await updateDoc(doc(db, COLLECTIONS.CHANNELS, channelId), data);
};

const updateChannelEdits = async (channelId: string, data: any) => {
  await updateDoc(doc(db, COLLECTIONS.CHANNEL_CHANGE_REQUESTS, channelId), data);
};

const deleteChannel = async (channelId: string) => {
  await deleteDoc(doc(db, COLLECTIONS.CHANNELS, channelId));
};

const deleteChannelEdits = async (channelId: string) => {
  await deleteDoc(doc(db, COLLECTIONS.CHANNEL_CHANGE_REQUESTS, channelId));
};

const duplicateChannel = async (channelId:string) => {
  const sourceDocRef = doc(db, COLLECTIONS.CHANNELS, channelId);
  const sourceDocSnapshot = await getDoc(sourceDocRef);
  let data = sourceDocSnapshot.data() as SKChannel
  const newData = {...data, status:ChannelState.DRAFT, subStatus:ChannelSubstate.NONE, createdDate: Timestamp.now(), updatedDate: Timestamp.now()}
  let newDocRef = await addDoc(collection(db, COLLECTIONS.CHANNELS), newData);
  newData.id = newDocRef.id
  return newData
}

const updateChannelEditStatus = async (channelId: string, status: ChannelState, subStatus: ChannelSubstate, reason?:string, note?:string,): Promise<void> =>  {
  try {
    console.log(status)
    console.log(channelId)
    await updateChannel(channelId, {status, subStatus});
    await updateChannelHistory(channelId, getChannelHistoryStatusString(status, subStatus, true), reason, note)
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
};

const updateChannelStatus = async (channelId: string, status: ChannelState, subStatus: ChannelSubstate, reason?:string, note?:string,): Promise<void> =>  {
  try {
    console.log(status)
    console.log(channelId)
    await updateChannel(channelId, {status, subStatus});
    await updateChannelHistory(channelId, getChannelHistoryStatusString(status, subStatus), reason, note)
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
};

const updateChannelHistory = async ( channelId:string, status:string, reason?:string, note?:string ) : Promise<void> => {
  try {
    if(reason){
      if(note){
        await addDoc(collection(db, COLLECTIONS.CHANNELS, channelId, SUBCOLLECTIONS.CHANNEL_STATUS_LOGS ), {status, createdDate: Timestamp.now(), reason, note} );
      }else{
        await addDoc(collection(db, COLLECTIONS.CHANNELS, channelId, SUBCOLLECTIONS.CHANNEL_STATUS_LOGS ), {status, createdDate: Timestamp.now(), reason} );
      }
    }else{
      await addDoc(collection(db, COLLECTIONS.CHANNELS, channelId, SUBCOLLECTIONS.CHANNEL_STATUS_LOGS ), {status, createdDate: Timestamp.now()} );
    }
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while updating Artefact Status');
  }
};

const getChannelHistory = async ( channelId:string) : Promise<SKChannelStatusHistory[]> => {
  let ref = collection(db, COLLECTIONS.CHANNELS, channelId, SUBCOLLECTIONS.CHANNEL_STATUS_LOGS)
  try {
    // Retrieve the documents from the "History" subcollection
    const querySnapshot = await getDocs(query(ref,orderBy("createdDate", "desc")));
    
    // Map over the documents and extract their data
    const historyData = querySnapshot.docs.map(doc => ({
      ...doc.data() // Document data
    })) as SKChannelStatusHistory[]

    return historyData;
  } catch (error) {
    console.error("Error getting History collection: ", error);
    throw error; // Handle the error appropriately
  }

  
}


const getChannelCounts = async (): Promise<{ [ChannelActionType.review]:number,[ChannelActionType.edit_review]:number, [ChannelActionType.active]: number; [ChannelActionType.withdrawn]: number; [ChannelActionType.rejected]: number; [ChannelActionType.flagged]: number }> => {
  const channelsRef = collection(db, COLLECTIONS.CHANNELS);
  const reportsRef = collection(db, `${COLLECTIONS.REPORTS}/channel/reports`);

  const inReviewQuery = query(channelsRef, where("status", "==", ChannelState.IN_REVIEW));
  const editReviewQuery = query(channelsRef, where("status", "==", ChannelState.ACTIVE), where("subStatus", "==", ChannelSubstate.EDIT_IN_REVIEW));
  const activeQuery = query(channelsRef, where("status", "==", ChannelState.ACTIVE));
  const withdrawnQuery = query(channelsRef, where("status", "==", ChannelState.DRAFT), where("subStatus", "==", ChannelSubstate.WITHDRAWN));
  const rejectedQuery = query(channelsRef, where("status", "==", ChannelState.DRAFT), where("subStatus", "==", ChannelSubstate.REJECTED));
  const flaggedQuery =  query(reportsRef, where("reportCount",">", 0));

  try {
    // Execute all queries in parallel
    const [inreviewSnap, editInReviewSnap, activeSnap, withdrawnSnap, rejectedSnap, flaggedSnap] = await Promise.all([
      getCountFromServer(inReviewQuery),
      getCountFromServer(editReviewQuery),
      getCountFromServer(activeQuery),
      getCountFromServer(withdrawnQuery),
      getCountFromServer(rejectedQuery),
      getCountFromServer(flaggedQuery)
    ]);

    return {
      [ChannelActionType.review]: inreviewSnap.data().count,
      [ChannelActionType.edit_review]: editInReviewSnap.data().count,
      [ChannelActionType.active]: activeSnap.data().count,
      [ChannelActionType.withdrawn]: withdrawnSnap.data().count,
      [ChannelActionType.rejected]: rejectedSnap.data().count,
      [ChannelActionType.flagged]: flaggedSnap.data().count,
    };
  } catch (error) {
    console.error("Error getting channel counts: ", error);
    return { [ChannelActionType.review]: 0,
      [ChannelActionType.edit_review]: 0,
      [ChannelActionType.active]: 0,
      [ChannelActionType.withdrawn]: 0,
      [ChannelActionType.rejected]: 0,
      [ChannelActionType.flagged]: 0, 
    }; // Return 0 for all if there's an error
  }
}

interface FetchChannelListResult {
  docs: SKChannel[];
  firstDoc: QueryDocumentSnapshot | undefined;
  lastDoc: QueryDocumentSnapshot | undefined;
  hasNext: boolean;
  hasPrev: boolean
}

const fetchReportedChannel = async (
  filterFields: string[],
  filterValues: unknown[],
  pageSize: number,
  moveTo?: Pagination,
  currentDoc?: QueryDocumentSnapshot,
  sortConfig?:{key:string; direction: "asc" | "desc"}
): Promise<FetchChannelListResult> => {
  try {
    const reportsRef = collection(db, COLLECTIONS.CHANNELS);

    // Step 1: Fetch top reported content IDs (sorted by `reportCount`)

    // const channelReportDoc = db.collection("reports").doc("channel");
    // const reportRef = channelReportDoc.collection("reports").doc(channelID);
    // const contentRef = db.collection(COLLECTIONS.CHANNELS).doc(channelID);
    // const userActionRef = reportRef.collection("reportedUsers").doc(userID);

    let reportsQuery = query(reportsRef, orderBy("lastReportedDate", "desc"), where("reportCount",">", 0), limit(pageSize + 1));
    
    const reportsSnapshot = await getDocs(reportsQuery);
    const docs = reportsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as SKChannel[];

    let firstDoc = docs.length > 0 ? reportsSnapshot.docs[0] : undefined;
    let lastDoc = docs.length > pageSize ? reportsSnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? reportsSnapshot.docs[pageSize - 1] : undefined);
    
    let hasNext = moveTo === Pagination.Next ? reportsSnapshot.size > pageSize : moveTo === Pagination.First && reportsSnapshot.size <= pageSize ? false : true;
    let hasPrev = !!currentDoc;

    switch (moveTo) {
      case Pagination.First:
        hasPrev = false;
        break;
      case Pagination.Last:
        hasNext = false;
        break;
      default:
        break;
    }

    return { docs, firstDoc, lastDoc, hasNext, hasPrev };
  } catch (error) {
    console.error("Error fetching reported content:", error);
    throw new Error("An error occurred while fetching data");
  }
};

interface ChannelReports {
  docs: SKChannelReport[];
  firstDoc: QueryDocumentSnapshot | undefined;
  lastDoc: QueryDocumentSnapshot | undefined;
  hasNext: boolean;
  hasPrev: boolean
}

const fetchChannelReports = async (
  channelId: string,
  pageSize: number,
  moveTo?: Pagination,
  currentDoc?: QueryDocumentSnapshot,
): Promise<ChannelReports> => {
  try {

    // const reportRef = contentReportDoc.collection("reports").doc(contentID);
    const reportsRef = collection(db, `reports/channel/reports/${channelId}/reportedUsers`);

    // Step 1: Fetch top reported content IDs (sorted by `reportCount`)

    // const channelReportDoc = db.collection("reports").doc("channel");
    // const reportRef = channelReportDoc.collection("reports").doc(channelID);
    // const contentRef = db.collection(COLLECTIONS.CHANNELS).doc(channelID);
    // const userActionRef = reportRef.collection("reportedUsers").doc(userID);

    let reportsQuery = query(reportsRef, orderBy("reportedDate", "desc"), limit(pageSize + 1));
    
    const reportsSnapshot = await getDocs(reportsQuery);

    const docs = reportsSnapshot.docs.map(doc =>  doc.data()) as SKChannelReport[];

    let firstDoc = docs.length > 0 ? reportsSnapshot.docs[0] : undefined;
    let lastDoc = docs.length > pageSize ? reportsSnapshot.docs[pageSize - 1] : (moveTo === Pagination.Previous ? reportsSnapshot.docs[pageSize - 1] : undefined);
    
    let hasNext = moveTo === Pagination.Next ? reportsSnapshot.size > pageSize : moveTo === Pagination.First && reportsSnapshot.size <= pageSize ? false : true;
    let hasPrev = !!currentDoc;

    switch (moveTo) {
      case Pagination.First:
        hasPrev = false;
        break;
      case Pagination.Last:
        hasNext = false;
        break;
      default:
        break;
    }

    return { docs, firstDoc, lastDoc, hasNext, hasPrev };
  } catch (error) {
    console.error("Error fetching reported content:", error);
    throw new Error("An error occurred while fetching data");
  }
};

export {
  getChannel,
  getUserCreatedChannel,
  getMyChannel,
  fetchChannel,
  fetchChannelReports,
  createChannel,
  updateChannel,
  deleteChannel,
  deleteChannelEdits,
  duplicateChannel,
  updateChannelStatus,
  updateChannelEditStatus,
  updateChannelHistory,
  getChannelHistory,
  getChannlesByIds,
  getChannelCounts,
  getChannelEdits,
  updateChannelEdits,
  createChannelEdits,
  fetchReportedChannel
};